import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

/**
 * Guard component to conditionally render children based on vendor KYC status.
 * Prevents unverified vendors from accessing restricted features like wallet, products, etc.
 * @param {React.ReactNode} children - Component to render if KYC is verified
 */
const KycGuard = ({ children }) => {
    // We check vendorInfo from local storage or redux depending on how it's stored.
    // In VendorDashboard, useVendorDashboard fetches live data, but for routing, 
    // local storage 'vendorInfo' is typically used.
    const vendorInfoStr = localStorage.getItem('vendorInfo');
    
    if (!vendorInfoStr) {
        return <Navigate to="/vendor/pending-approval" replace />;
    }

    try {
        const vendor = JSON.parse(vendorInfoStr);
        
        // If KYC is not verified or approved, redirect to dashboard or KYC page
        if (vendor.kycStatus !== 'verified' && vendor.kycStatus !== 'approved') {
            return <Navigate to="/vendor/dashboard" replace />;
        }
        
        return children;
    } catch (e) {
        return <Navigate to="/vendor/pending-approval" replace />;
    }
};

KycGuard.propTypes = {
    children: PropTypes.node
};

export default KycGuard;
